

export class EmpNameWithCode implements IEmpNameWithCode {
    id!: number;
    approverId!: number | undefined;
    employeeName!: string | undefined;
    employeeNameOnly!: string | undefined;
    isActive!: boolean;
    branchId!: number;

    constructor(data?: IEmpNameWithCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approverId = _data["approverId"];
            this.employeeName = _data["employeeName"];
            this.employeeNameOnly = _data["employeeNameOnly"];
            this.isActive = _data["isActive"];
            this.branchId = _data["branchId"];
        }
    }

    static fromJS(data: any): EmpNameWithCode {
        data = typeof data === 'object' ? data : {};
        let result = new EmpNameWithCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approverId"] = this.approverId;
        data["employeeName"] = this.employeeName;
        data["employeeNameOnly"] = this.employeeNameOnly;
        data["isActive"] = this.isActive;
        data["branchId"] = this.branchId;
        return data; 
    }
}

export interface IEmpNameWithCode {
    id: number;
    approverId: number | undefined;
    employeeName: string | undefined;
    employeeNameOnly: string | undefined;
    isActive: boolean;
    branchId: number;
}

